import React, { useState } from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import {isNegative, trendingColor, nameStyle, getPredAnalysisColor, getVolatilityColor} from './scheme_table_helpers';

import {renderTooltipMinReturns, renderTooltipMaxReturns, renderTooltipPredAnalysis } from './scheme_table_helpers';
import {renderTooltipMeanProbable, renderTooltipMaxProbable, renderTooltipPNAVvolatility } from './scheme_table_helpers';
import {renderHeaderAndTooltip, } from './scheme_table_helpers';
import {renderTooltipSchemeName, renderTooltipStability,  renderTooltipLaunchGroup,} from './scheme_table_helpers';
import {renderTooltipCAGRGroup, renderTooltip180DaysReturns, renderTooltipAnnualizedReturns} from './scheme_table_helpers';
import {renderTooltipCAGRRank, renderTooltipCurrentRank, renderTooltipLastRank} from './scheme_table_helpers';

import WatchListModal from '../../components/WatchListModal';
import api from '../../api/api'; // Axios wrapper

import './SchemeListTable.css';

// hoveredId, setHoveredId, 

export default function SchemeListTable({
    handleSort, renderSimpleSort, getMultiSortIndicatorUpDown,
    pageData, handleCellClick,
    baseScheme, selectedScheme, searchTerm,
    isAddToWatchlistApplicable = true,
    isDeleteFromWatchlistApplicable = false,
}) {
  const [hoveredId, setHoveredId] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showToastMsg, setShowToastMsg] = useState(false);
  const [addToWatchListMessage, setAddToWatchListMessage] = useState("");

    // Handles individual row selection
  const handleSelectRow = (id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const processAddToWatchList = async (watchListName, addNewWatchlist) => {
    const payload = {
      watchlistName: watchListName,
      addNewWatchList: addNewWatchlist,
      selectedSchemes: [...selectedIds],
    };
    //setMultiSelect(false);
    setSelectedIds([]);
    setAddToWatchListMessage("");
    try {
      const res = await api.post('/update-my-watchlist', payload); // JSON.stringify([selectedScheme.id]));
      if (res.status === 200) {
        setAddToWatchListMessage(res.data.message || 'Successfully Added Scheme to WatchList');
      } else if (res.status >= 400) {
        setAddToWatchListMessage(res.data.error || 'Could not add Scheme to WatchList');
      }
      setShowToastMsg(true);
      return res.data;
    } catch (err) {
      setAddToWatchListMessage(err.response?.data?.message || err.response?.data?.error || 'Could not add Scheme to WatchList');
      setShowToastMsg(true);
    }
    return null;
  }

  const handleWatchListSubmit = async (data) => {
    setShowModal(false);
    processAddToWatchList(data.watchlistName, data.addNewWatchlist);
  };

  //                     onClick={() => handleRowClick(scheme)} /// Was passed as param

  return (
    <>
        <Table striped bordered hover responsive="sm" size="sm" style={{fontSize:'0.85rem'}}>
            <thead>
                <tr>
                    {
                        isAddToWatchlistApplicable ?
                            (<th>
                                <Button variant="outline-secondary" onClick={() => setShowModal(true)} 
                                        disabled={selectedIds.length === 0} className="mt-1"
                                        style={{fontSize:'0.80rem'}}
                                >
                                    <b>Add to Watchlist</b>
                                </Button>
                            </th>):
                            (<></>)
                    }

                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('currentRank')}>
                        {renderHeaderAndTooltip('Current Rank', renderTooltipCurrentRank, 'current-rank', renderSimpleSort, 'currentRank', false, 0)}
                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('lastRank')}>
                        {renderHeaderAndTooltip('Last Rank', renderTooltipLastRank, 'last-rank', renderSimpleSort, 'lastRank', false, 0)}
                    </th>

                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('name')}>
                        {renderHeaderAndTooltip('Scheme Name', renderTooltipSchemeName, 'scheme-name', renderSimpleSort, 'name', false, 0)}

                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" >Last Actual NAV</th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" >Last Actual NAV Date</th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('stability')}>
                        {renderHeaderAndTooltip('Scheme Stability', renderTooltipStability, 'scheme-stability', renderSimpleSort, 'stability', false, 0)}
                    </th>

                    <th className="text-center align-middle table-header-bg table-header-sticky text-primary" >pNAV Calculated For</th>
            
                    <th className="text-center align-middle table-header-bg table-header-sticky" >
                        {renderHeaderAndTooltip('pNAV PEAK 1', renderTooltipMaxProbable, 'high-predicted-NAV', null, 'maxProbableNav', false, 0)}
                    </th>  
                    <th className="text-center align-middle table-header-bg table-header-sticky" >
                        {renderHeaderAndTooltip('pNAV PEAK 2', renderTooltipMeanProbable, 'mean-predicted-NAV', null, 'meanProbableNav', false, 0)}
                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('predAnalysis')}>
                        {renderHeaderAndTooltip('Prediction Analysis', renderTooltipPredAnalysis, 'pred-Analysis', getMultiSortIndicatorUpDown, 'predAnalysis', true, 1)}
                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('predVolatility')}>
                        {renderHeaderAndTooltip('pNAV Volatility', renderTooltipPNAVvolatility, 'pNAV-Volatility', getMultiSortIndicatorUpDown, 'predVolatility', true, '2')}

                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('cagrGroup')}>
                        {renderHeaderAndTooltip('CAGR Group', renderTooltipCAGRGroup, 'cagr-group', getMultiSortIndicatorUpDown, 'cagrGroup', false,'3')}
                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('cagr_rank')}>
                        {renderHeaderAndTooltip('CAGR Rank', renderTooltipCAGRRank, 'cagr-rank', renderSimpleSort, 'cagr_rank', false, 0)}
                    </th> 
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('maxProbableReturns')}>
                        {renderHeaderAndTooltip('pNAV Max - Returns Trend', renderTooltipMaxReturns, 'max-predicted-returns', getMultiSortIndicatorUpDown, 'maxProbableReturns', false, '4')}
                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('minProbableReturns')}>
                        pNAV Min - Returns Trend&nbsp;
                        {renderSimpleSort('minProbableReturns')}
                    </th> 
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('launchGroup')}>
                        {renderHeaderAndTooltip('Scheme Launch Group', renderTooltipLaunchGroup, 'launch-group', getMultiSortIndicatorUpDown, 'launchGroup', false, '5')}
                    </th>

                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('annualizedReturns1')}>
                        {renderHeaderAndTooltip('Annualized Returns 1', renderTooltipAnnualizedReturns, 'Annualized-Returns', getMultiSortIndicatorUpDown, 'annualizedReturns1', false, '6.1')}
                    </th>
                    <th className="text-center align-middle table-header-bg table-header-sticky" onClick={() => handleSort('change180d')}>
                        {renderHeaderAndTooltip('% Change in 180 Days', renderTooltip180DaysReturns, '180Days-Returns', getMultiSortIndicatorUpDown, 'change180d', false, '6.2')}

                    </th>
                </tr>
            </thead>
            <tbody style={{fontSize:'0.80rem'}}>
            {pageData.map(scheme => (
                    <tr key={scheme.id}
                        className={(baseScheme && (scheme.scheme_code === baseScheme.scheme_code)) ? 'disabled-row' : undefined}
                        style={{ position: 'relative' }}
                    >
                        {
                            isAddToWatchlistApplicable ?
                            (
                                <td className="text-center align-middle">
                                    <Form.Check 
                                        type="checkbox" 
                                        checked={selectedIds.includes(scheme.id)}
                                        onChange={() => handleSelectRow(scheme.id)}
                                        className="custom-checkbox"
                                    />
                                </td>
                            ):
                            (<></>)
                        }
                        <td className="text-center align-middle" style={{ backgroundColor: '#fff4e6' }}>{scheme.currentRank == '11111' ? '--' : scheme.currentRank}</td>
                        <td className="text-center align-middle" style={{ backgroundColor: '#fff4e6' }}>{scheme.lastRank == '11111' ? '--' : scheme.lastRank}</td>
                        <td 
                            onClick={() => handleCellClick(scheme, "Name")}
                            onMouseEnter={() => setHoveredId(scheme.id)}
                            onMouseLeave={() => setHoveredId(null)}
                            className={(baseScheme && (scheme.scheme_code === baseScheme.scheme_code)) ? undefined : 'clickable-cell'}
                            style={nameStyle(scheme.minProbableReturns, scheme.maxProbableReturns, scheme.annualizedReturns1, scheme.predVolatility, (scheme.id === selectedScheme?.id))}
                        >
                            {scheme.name}
                            {/* Conditionally display message */}
                            {hoveredId === scheme.id && (
                                <div style={{
                                    position: 'absolute',
                                    backgroundColor: '#333',
                                    color: '#fff',
                                    padding: '5px',
                                    borderRadius: '4px',
                                    top: '-10px',
                                    left: '50px',
                                    zIndex: 1
                                }}>
                                Click to view more details 
                            </div>
                            )}
                        </td>
                        <td>{scheme.lastActualNav}</td>
                        <td>{scheme.lastActualNavDate}</td>
                        <td>{scheme.stability}</td>
                        <td style={{ backgroundColor: '#fff4e6' }}>{scheme.calculatedFor}</td>
                        <td
                            style={{
                                backgroundColor: '#fff4e6',
                                color: isNegative(scheme.maxProbableNav) ? 'red' : 'inherit',
                            }}
                        >
                            {scheme.maxProbableNav}
                        </td>
                        <td
                            style={{
                                backgroundColor: '#fff4e6',
                                color: isNegative(scheme.meanProbableNav) ? 'red' : 'inherit',
                            }}
                        >
                            {scheme.meanProbableNav}
                        </td>
                        <td
                            style={ getPredAnalysisColor(scheme.predAnalysis)}
                        >
                            {scheme.predAnalysis}
                        </td>
                        <td 
                            style={{
                                backgroundColor: '#fff4e6',
                                color: getVolatilityColor(scheme.predVolatility)
                            }}>
                                {scheme.predVolatility}
                        </td>
                        <td>{scheme.cagrGroup}</td>
                        <td>{scheme.cagr_rank}</td>

                        <td 
                            style={{ 
                                backgroundColor: '#fff4e6' ,
                                color: trendingColor(scheme.maxProbableReturns),
                            }}
                            >
                            {scheme.maxProbableReturns}
                        </td>
                        <td
                            style={{ 
                                backgroundColor: '#fff4e6' ,
                                color: trendingColor(scheme.minProbableReturns),
                            }}
                            >
                            {scheme.minProbableReturns}
                        </td>
                        <td><b>{scheme.launchGroup}</b></td>
                        <td
                            style={{
                                backgroundColor: '#90EE90',
                                color: isNegative(scheme.annualizedReturns1) ? 'red' : undefined,
                            }}
                            >
                            {scheme.annualizedReturns1}
                        </td>
                        <td
                            style={{
                                backgroundColor: '#90EE90',
                                color: isNegative(scheme.change180d) ? 'red' : undefined,
                            }}
                            >
                            {scheme.change180d}                          
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
        {isAddToWatchlistApplicable? 
            (<>
                <WatchListModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    newWatchlistOption={true}
                    onSubmit={handleWatchListSubmit}
                />
                <ToastContainer position="middle-center" className="p-3">
                    <Toast onClose={() => setShowToastMsg(false)} show={showToastMsg} delay={5000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Notification</strong>
                        <small>Watchlist Addition</small>
                    </Toast.Header>
                    <Toast.Body>{addToWatchListMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>

            </>):(<></>)
        }
    </>
  )
}
